// extracted by mini-css-extract-plugin
export default {"privacyContainer":"Privacy_privacyContainer__Q5cmD","heading":"Privacy_heading__EPa12","date":"Privacy_date__W0B7A"};